import VendorAgentsContainer from './VendorAgentsContainer';

export default VendorAgentsContainer;
